<template>
    <div ref="productComponent"></div>
</template>
<script type="text/babel">
export default {
    data() {
        return {
            scriptURL: 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js'
        }
    },
    mounted() {
        if (window.ShopifyBuy) {
            if (window.ShopifyBuy.UI) {
                this.shopifyBuyInit();
            } else {
                this.loadScript();
            }
        } else {
            this.loadScript();
        }
    },
    props: ['domain', 'accessToken', 'productId'],
    computed: {},
    methods: {
        loadScript() {
            let script = document.createElement('script');
            script.async = true;
            script.src = this.scriptURL;
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
            script.onload = this.shopifyBuyInit;
        },
        shopifyBuyInit() {
            let client = ShopifyBuy.buildClient({
                domain: this.domain,
                storefrontAccessToken: this.accessToken,
            });
            ShopifyBuy.UI.onReady(client).then((ui) => {
                ui.createComponent('product', {
                    id: this.productId,
                    node: this.$refs.productComponent,
                    moneyFormat: '%24%20%7B%7Bamount%7D%7D',
                    options: {
                        "product": {
                            "styles": {
                                "product": {
                                    "@media (min-width: 601px)": {
                                        "max-width": "calc(25% - 20px)",
                                        "margin-left": "20px",
                                        "margin-bottom": "50px"
                                    }
                                },
                                "button": {
                                    "font-family": "Oswald, sans-serif",
                                    "font-weight": "bold",
                                    "font-size": "22px",
                                    "padding-top": "20px",
                                    "padding-bottom": "20px",
                                    "color": "#000000",
                                    ":hover": {
                                        "color": "#009ace",
                                        "background-color": "#000000"
                                    },
                                    "background-color": "#009ace",
                                    ":focus": {
                                        "background-color": "#009ace"
                                    },
                                    "border-radius": "5px",
                                    "padding-left": "99px",
                                    "padding-right": "99px"
                                },
                                "quantityInput": {
                                    "font-size": "18px",
                                    "padding-top": "17px",
                                    "padding-bottom": "17px"
                                }
                            },
                            "contents": {
                                "img": false,
                                "title": false,
                                "price": false
                            },
                            "text": {
                                "button": "BUY NOW"
                            },
                            "googleFonts": [
                                "Oswald"
                            ]
                        },
                        "productSet": {
                            "styles": {
                                "products": {
                                    "@media (min-width: 601px)": {
                                        "margin-left": "-20px"
                                    }
                                }
                            }
                        },
                        "modalProduct": {
                            "contents": {
                                "img": false,
                                "imgWithCarousel": true,
                                "button": false,
                                "buttonWithQuantity": true
                            },
                            "styles": {
                                "product": {
                                    "@media (min-width: 601px)": {
                                        "max-width": "100%",
                                        "margin-left": "0px",
                                        "margin-bottom": "0px"
                                    }
                                },
                                "button": {
                                    "font-family": "Oswald, sans-serif",
                                    "font-weight": "bold",
                                    "font-size": "18px",
                                    "padding-top": "17px",
                                    "padding-bottom": "17px",
                                    "color": "#000000",
                                    ":hover": {
                                        "color": "#000000",
                                        "background-color": "#008bb9"
                                    },
                                    "background-color": "#009ace",
                                    ":focus": {
                                        "background-color": "#008bb9"
                                    },
                                    "border-radius": "5px",
                                    "padding-left": "100px",
                                    "padding-right": "100px"
                                },
                                "quantityInput": {
                                    "font-size": "18px",
                                    "padding-top": "17px",
                                    "padding-bottom": "17px"
                                }
                            },
                            "googleFonts": [
                                "Oswald"
                            ],
                            "text": {
                                "button": "Add to cart"
                            }
                        },
                        "option": {
                            "styles": {
                                "label": {
                                    "font-family": "Roboto, sans-serif",
                                    "font-weight": "bold",
                                    "font-size": "17px",
                                    "color": "#000000"
                                },
                                "select": {
                                    "font-family": "Roboto, sans-serif",
                                    "font-weight": "normal"
                                }
                            },
                            "googleFonts": [
                                "Oswald"
                            ]
                        },
                        "cart": {
                            "events": {
                                "afterRender": shipearlyBuyButtonCartInit
                            },
                            "styles": {
                                "button": {
                                    "font-family": "Oswald, sans-serif",
                                    "font-weight": "bold",
                                    "font-size": "18px",
                                    "padding-top": "17px",
                                    "padding-bottom": "17px",
                                    "color": "#000000",
                                    ":hover": {
                                        "color": "#000000",
                                        "background-color": "#008bb9"
                                    },
                                    "background-color": "#009ace",
                                    ":focus": {
                                        "background-color": "#009ace"
                                    },
                                    "border-radius": "5px"
                                },
                                "title": {
                                    "color": "#000000",
                                    "font-weight": "bold",
                                    "font-size": "18px"
                                },
                                "header": {
                                    "color": "#000000"
                                },
                                "lineItems": {
                                    "color": "#000000"
                                },
                                "subtotalText": {
                                    "color": "#000000",
                                    "font-size": "18px"
                                },
                                "subtotal": {
                                    "color": "#000000",
                                    "font-size": "18px",
                                    "font-weight": "bold"
                                },
                                "notice": {
                                    "color": "#000000"
                                },
                                "currency": {
                                    "color": "#000000"
                                },
                                "close": {
                                    "color": "#000000",
                                    ":hover": {
                                        "color": "#000000"
                                    }
                                },
                                "empty": {
                                    "color": "#000000"
                                },
                                "noteDescription": {
                                    "color": "#000000"
                                },
                                "discountText": {
                                    "color": "#000000"
                                },
                                "discountIcon": {
                                    "fill": "#000000"
                                },
                                "discountAmount": {
                                    "color": "#000000"
                                }
                            },
                            "text": {
                                "total": "Subtotal",
                                "notice": "Shipping and taxes are added at checkout.",
                                "button": "Checkout"
                            },
                            "googleFonts": [
                                "Roboto"
                            ]
                        },
                        "toggle": {
                            "styles": {
                                "toggle": {
                                    "font-family": "Roboto, sans-serif",
                                    "font-weight": "bold",
                                    "background-color": "#009ace",
                                    ":hover": {
                                        "background-color": "#009ace"
                                    },
                                    ":focus": {
                                        "background-color": "#009ace"
                                    }
                                },
                                "count": {
                                    "font-size": "18px",
                                    "color": "#fff",
                                    ":hover": {
                                        "color": "#000000"
                                    }
                                },
                                "iconPath": {
                                    "fill": "#fff"
                                }
                            },
                            "googleFonts": [
                                "Roboto"
                            ]
                        },
                        "lineItem": {
                            "styles": {
                                "variantTitle": {
                                    "color": "#000000",
                                    "font-size": "16px",
                                },
                                "title": {
                                    "color": "#000000"
                                },
                                "itemTitle": {
                                    "color": "#000000",
                                    "font-size": "18px",
                                    "font-weight": "bold",
                                },
                                "price": {
                                    "color": "#000000"
                                },
                                "fullPrice": {
                                    "color": "#000000"
                                },
                                "discount": {
                                    "color": "#000000"
                                },
                                "discountIcon": {
                                    "fill": "#000000"
                                },
                                "quantity": {
                                    "color": "#000000"
                                },
                                "quantityIncrement": {
                                    "color": "#000000",
                                    "border-color": "#000000"
                                },
                                "quantityDecrement": {
                                    "color": "#000000",
                                    "border-color": "#000000"
                                },
                                "quantityInput": {
                                    "color": "#000000",
                                    "border-color": "#000000"
                                }
                            }
                        }
                    },
                });
            });
        }
    }
}
</script>
